import Image from "@tiptap/extension-image"
import { mergeAttributes } from "@tiptap/core"

export const CustomImageExtension = Image.extend({
  name: "custom-image",

  addOptions() {
    return {
      ...Image.options,
      inline: true,
      HTMLAttributes: { class: "custom-image" }
    }
  },

  addAttributes() {
    return {
      ...Image.config.addAttributes(),
      float: { default: "none" },
      size: { default: "default" }
    }
  },

  addCommands() {
    return {
      setImage: (options) => ({ tr, commands }) => {
        if (tr.selection?.node?.type?.name === "custom-image") {
          return commands.updateAttributes("custom-image", options)
        }
        return commands.insertContent({ type: this.name, attrs: options })
      }
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    HTMLAttributes.class = ` custom-image-${node.attrs.size}`
    HTMLAttributes.class += ` custom-image-float-${node.attrs.float}`
    return ["img", mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)]
  }
})
